import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';

declare var google: any;
declare var gapi: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  private gapiSetup: boolean = false;
  private tokenClient: any;
  private accessToken: string = '';

  private readonly CLIENT_ID: string = '111103509215-0o58lcbdeo6eg5520jvtah497hbks8jm.apps.googleusercontent.com';
  private readonly API_KEY: string = 'AIzaSyAJHYeyp-vffmAP9cn5p2ZelArA5c8iJpk';
  private readonly DISCOVERY_DOCS: string[] = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
  private readonly SCOPES: string = 'https://www.googleapis.com/auth/calendar.readonly';

  constructor() {
    this.loadGisClient();
  }

  private loadGisClient(): void {
    const gisScript = document.createElement('script');
    gisScript.src = 'https://accounts.google.com/gsi/client';
    gisScript.async = true;
    gisScript.defer = true;
    document.body.appendChild(gisScript);

    const gapiScript = document.createElement('script');
    gapiScript.src = 'https://apis.google.com/js/api.js';
    gapiScript.async = true;
    gapiScript.defer = true;
    gapiScript.onload = this.initClient.bind(this);
    document.body.appendChild(gapiScript);
  }

  initClient(): void {
    gapi.load('client', () => {
      gapi.client.init({
        apiKey: this.API_KEY,
        discoveryDocs: this.DISCOVERY_DOCS
      }).then(() => {
        this.gapiSetup = true;
      }).catch((error: any) => {
        console.error('Error initializing GAPI client', error);
      });
    });
  }

  public initAuth(): void {
    this.tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: this.CLIENT_ID,
      scope: this.SCOPES,
      callback: (tokenResponse: any) => {
        this.accessToken = tokenResponse.access_token;
        gapi.auth.setToken({ access_token: this.accessToken });
      }
    });
  }

  public signIn(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.gapiSetup) {
        this.initClient();
      }
      this.initAuth();
      this.tokenClient.requestAccessToken();
      resolve();
    });
  }

  public signOut(): void {
    google.accounts.id.disableAutoSelect();
    this.accessToken = '';
    console.log('User signed out');
  }

  // public listUpcomingEvents(): Observable<any> {
  //   if (!this.gapiSetup) {
  //     console.error('GAPI client not initialized');
  //     return from(Promise.reject('GAPI client not initialized'));
  //   }
  //   return from(gapi.client.calendar.events.list({
  //     'calendarId': 'primary',
  //     'timeMin': (new Date()).toISOString(),
  //     'showDeleted': false,
  //     'singleEvents': true,
  //     'maxResults': 10,
  //     'orderBy': 'startTime'
  //   }));
  // }
  public listUpcomingEvents(): Observable<any> {
    if (!this.gapiSetup) {
      console.error('GAPI client not initialized');
      return from(Promise.reject('GAPI client not initialized'));
    }
    return from(gapi.client.calendar.events.list({
      'calendarId': 'primary',
      'timeMin': (new Date()).toISOString(),
      'showDeleted': false,
      'singleEvents': true,
      'maxResults': 10,
      'orderBy': 'startTime'
    }).then((response: any) => {
      return response.result.items.map((event: any) => {
        return {
          title: event.summary,
          applicantName: event.applicantName,
          start: event.start.dateTime || event.start.date,
          end: event.end.dateTime || event.end.date,
          htmlLink: event.htmlLink
        };
      });
    }));
  }
}
